<template>
  <layout-main-inner title="即时库存">
    <div slot="action">
      <el-radio-group :value="config.daysInStock">
        <el-radio-button
          :label="0"
          @click.native="handleClick(0)">即时库存</el-radio-button>
        <el-radio-button
          :label="30"
          @click.native="handleClick(30)">在库大于30天</el-radio-button>
      </el-radio-group>
    </div>

    <overview-data
      ref="overviewData"
      :option="config" />

    <top-brand-data
      ref="topBrandData"
      :option="config" />

    <brand-count-table
      ref="brandCountTable"
      :option="config" />
  </layout-main-inner>
</template>

<script>
import OverviewData from './busi/overview-data.vue'
import TopBrandData from './busi/top-brand-data.vue'
import BrandCountTable from './busi/brand-count-table.vue'
export default {
  name: 'WmsInventoryPage',
  components: { OverviewData, TopBrandData, BrandCountTable },
  data() {
    return {
      loading: false,
      config: { daysInStock: 30 }
    }
  },
  methods: {
    handleClick(daysInStock) {
      this.config.daysInStock = daysInStock
      this.$refs.overviewData.fetchList()
      this.$refs.topBrandData.fetchList()
      this.$refs.brandCountTable.fetchList()
    }

  }
}
</script>
